// extracted by css-extract-rspack-plugin
export default {"field":"PermissionForm__field--wexvS"};